import { dateFormatter } from "PFCore/helpers/date_formatter";
import { useMemo } from "react";

import { useCoreContext } from "../core_context";

export const useDateFormatter = () => {
  const { dateFormat, isAM } = useCoreContext();
  return useMemo(() => dateFormatter(dateFormat, isAM), [dateFormat, isAM]);
};
